import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'aesys-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss']
})
export class GenericDialogComponent {

  message = '';
  positiveButton = '';
  negativeButton = '';

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    if (data.positiveButton != null) {
      this.positiveButton = data.positiveButton;
    }
    if (data.negativeButton != null) {
      this.negativeButton = data.negativeButton;
    }
  }

  negativeButtonAvailable(): boolean {
    if (this.negativeButton != null && this.negativeButton != undefined && this.negativeButton != '') {
      return true;
    } else {
      return false;
    }
  }
}
